module.exports = __webpack_public_path__ + "static/img/bundles-mobile.645d53b3.svg";